import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import authReducer from './slices/auth.slice';
import applicationsReducer from './slices/applications.slice';
import pushReducer from './slices/push.slice';
import statsReducer from './slices/stats.slice';
import dashboardReducer from './slices/dashboard.slice';
import uiReducer from './slices/ui.slice';
import abTestReducer from './slices/abTest.slice';
import globalSegmentsReducer from './slices/globalSegments.slice';
import globalCampaignsReducer from './slices/globalCampaigns.slice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    applications: applicationsReducer,
    push: pushReducer,
    globalSegments: globalSegmentsReducer,
    globalCampaigns: globalCampaignsReducer,
    stats: statsReducer,
    ui: uiReducer,
    dashboard: dashboardReducer,
    abTest: abTestReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['push/sendPush/fulfilled'],
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        ignoredPaths: ['items.dates'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});


export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export * from './slices/auth.slice';
export * from './slices/ui.slice';